const STATS = [
    { num: "12", label: "Fliaš v sérii" },
    { num: "1", label: "Jediná edícia" },
    { num: "06", label: "Surovín" },
    { num: "100%", label: "Domáce" },
];

export const Stats = () => {
    return (
        <section
            data-testid="stats-section"
            className="relative px-6 sm:px-10 py-16 sm:py-20 border-t border-b border-white/10 bg-gradient-to-b from-[#0A0A0A] to-black"
        >
            <div className="max-w-[1400px] mx-auto grid grid-cols-2 sm:grid-cols-4 gap-px bg-white/10 border border-white/10">
                {STATS.map((s) => (
                    <div
                        key={s.label}
                        data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="bg-black p-6 sm:p-10 group hover:bg-[#D91C1C] transition-colors duration-500 cursor-default"
                    >
                        <div className="font-display text-5xl sm:text-7xl text-white leading-none tracking-tighter">
                            {s.num}
                        </div>
                        <div className="mt-3 text-[10px] sm:text-xs uppercase tracking-[0.25em] text-white/50 group-hover:text-white/90 transition-colors">
                            {s.label}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};
